import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = function() {
  platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
};

const httpRequest = function(options) {
  if (! options || ! options.url) {
      throw new Error('Specify request URL');
  }

  const timeout = options.timeout ? options.timeout : 0;

  let _xhr = new XMLHttpRequest();
  _xhr.open('GET', options.url, true);

  _xhr.timeout = timeout;
  _xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

  _xhr.onreadystatechange = function() {
      if (this.readyState === 4) {
          const responseHeaders = this.getAllResponseHeaders();

          if (this.status >= 200 && this.status < 400) {
              if (options.onSuccess) {
                  options.onSuccess(this.responseText, this.status, responseHeaders, this);
              }
          } else {
              if (options.onError) {
                  options.onError(this, this.status, responseHeaders);
              }
          }
      }
  };

  if (options.onTimeout) {
      _xhr.ontimeout = options.onTimeout;
  }

  _xhr.send();
  _xhr = null;
};

if (! environment.production) {
  bootstrap();
} else {
  httpRequest({
      url: environment.publicApiUrl + '/config/json',
      onSuccess: function(response, statusCode, responseHeaders, xhr) {
        let config;
        try {
          config = JSON.parse(response);
        } catch (ex) {
          console.error('Configuration file is not a valid JSON: ' + ex);
          return;
        }
        // Configuration from the server has priority
        for (const key of Object.keys(config)) {
          if (! environment[key]) {
            environment[key] = config[key];
          }
        }
        // Object.assign(environment, config);
        bootstrap();
      },
      onError: function(response, statusCode) {
        console.error('Error loading application configuration');
      }
  });
}
